module.exports = __webpack_public_path__ + "img/enroll_course.ef036d28.png";